import Home from "./components/page/Home";

export const App = Home;

export default App;
